import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { TApiButtonCommandFn } from ".";

import { useJourney } from "modules";

export const usePopToRoot = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { previousStepCallback } = useJourney();

  const buildBackAction = useCallback(() => {
    const locationState = (location.state || {}) as { from?: string };
    const rootPath = locationState.from || "/";

    return () => navigate(rootPath, { replace: true });
  }, [navigate, location.state]);

  const popToRootCommand: TApiButtonCommandFn = useCallback(async () => {
    const goBackAction = buildBackAction();
    const callback = previousStepCallback(goBackAction);
    callback();
  }, [buildBackAction, previousStepCallback]);

  return popToRootCommand;
};
